module.exports = __webpack_public_path__ + "static/media/path-2.a75ed73b.svg";